module.exports = __webpack_public_path__ + "static/media/icon_check.25628d13.svg";